import { NgModule } from 'ng-metadata/core';
import { AlphabetStripComponent } from './alphabet-strip.component';

@NgModule({
  declarations: [
    AlphabetStripComponent,
  ],
})
export class AlphabetStripModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/alphabet-strip/alphabet-strip.module.ts